<template>
  <v-app light>
    <SideBarMenu :items="items" />
    <v-toolbar dark :color="color" fixed app>
      <v-toolbar-side-icon @click="toggleSideBar" />
      <v-toolbar-title class="white--text fm-18px">{{$store.state.title}}</v-toolbar-title>
      <v-spacer />
        <v-speed-dial
          v-if="$store.state.Action.actions.length>0 && $store.state.Action.actions.find(x => x.tooltip === 'Upload') && $store.state.Action.actions.find(x => x.tooltip === 'Upload').render"
          v-model="fab2"
          class="downloadtop hidden-sm-and-down"
          direction="bottom"
          transition="slide-y-transition">
          <v-btn
            slot="activator"
            fab
            outline
            small
            v-model="fab2">
            <v-icon>attachment</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn :key="index" bottom v-for="(action, index) in $store.state.Action.actions"
                 :color="action.color"
                 fab
                 small
                 @click.native="actionHandler(action)"
                 :disabled="action.disabled"
                 :to="action.to"
                 v-if="renderAction(action) && action.type === 'Download'">
            <v-icon>{{action.icon}}</v-icon>
          </v-btn>
        </v-speed-dial>
        <v-tooltip class="hidden-sm-and-down" :key="index" bottom v-for="(action, index) in $store.state.Action.actions">
          <v-btn @click.native="actionHandler(action)"
                 :disabled="action.disabled"
                 slot="activator"
                 :color="action.color"
                 :to="action.to"
                 v-if="renderAction(action) && action.tooltip === 'Approve' && action.type != 'Download'">
            <v-icon>{{action.icon}}</v-icon>
            &nbsp;
            Process Approval
          </v-btn>
          <v-btn icon
                 @click.native="actionHandler(action)"
                 :disabled="action.disabled"
                 slot="activator"
                 :to="action.to"
                 v-if="renderAction(action) && action.tooltip != 'Approve' && action.type != 'Download'">
            <v-icon>{{action.icon}}</v-icon>
          </v-btn>
          <span>{{action.tooltip || action.label}}</span>
        </v-tooltip>
    </v-toolbar>
    <v-content v-scroll="onScroll">
      <router-view />
      <v-btn :class="$store.state.Action.actions.length>0 && $store.state.Action.actions.find(x => x.tooltip === 'Upload') && $store.state.Action.actions.find(x => x.tooltip === 'Upload').render ?'scrol-top':'scrol-top2'" v-if="offsetTop >=20"
        color="primary"
        dark
        small
        @click="backtoTop"
        fixed
        bottom
        right
        fab>
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
      <v-speed-dial
          v-if="$store.state.Action.actions.length>0 && $store.state.Action.actions.find(x => x.tooltip === 'Upload') && $store.state.Action.actions.find(x => x.tooltip === 'Upload').render"
          v-model="fab2"
          bottom
          right
          fixed
          class="hidden-md-and-up download"
          direction="top"
          transition="slide-y-transition">
          <v-btn
            slot="activator"
            color="info"
            dark
            fab
            small
            hover
            v-model="fab2">
            <v-icon>attachment</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn :key="index" bottom v-for="(action, index) in $store.state.Action.actions"
                 :color="action.color"
                 fab
                 small
                 @click.native="actionHandler(action)"
                 :disabled="action.disabled"
                 :to="action.to"
                 v-if="renderAction(action) && action.type === 'Download'">
            <v-icon>{{action.icon}}</v-icon>
          </v-btn>
        </v-speed-dial>
      <v-speed-dial
          v-if="$store.state.Action.actions.length>0"
          v-model="fab"
          bottom
          right
          fixed
          class="hidden-md-and-up"
          direction="top"
          transition="slide-y-transition">
          <v-btn
            slot="activator"
            color="info"
            dark
            fab
            small
            hover
            v-model="fab">
            <v-icon>more_vert</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn :key="index" bottom v-for="(action, index) in $store.state.Action.actions"
                 color="info"
                 fab
                 small
                 @click.native="actionHandler(action)"
                 :disabled="action.disabled"
                 :to="action.to"
                 v-if="renderAction(action) && action.type != 'Download'">
            <v-icon>{{action.icon}}</v-icon>
          </v-btn>
        </v-speed-dial>
    </v-content>
    <Confirmation :title="confirmation.title"
                  :message="confirmation.message" :buttons="confirmation.buttons" ref="confirmation" />
    <Notification @close="closeNotification" />
    <history v-model="historyData.status" :data="historyData.data"/>
    <ApprovalH v-model="ApprovalHData.status" :data="ApprovalHData.data"/>
    <ApprovalN v-model="ApprovalNData" />
  </v-app>
</template>

<script>
import SideBarMenu from '@/components/SideBarMenu'
import Notification from '@/components/dialogs/Notification'
import ActionBase from '@/components/ActionBase'
import Confirmation from '@/components/dialogs/Confirmation'
import history from '@/components/dialogs/DataTrailHistory'
import ApprovalH from '@/components/dialogs/ApprovalTrailHistory'
import ApprovalN from '@/components/dialogs/ApprovalNotification'

import Vuex from 'vuex'

const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'home',
  extends: ActionBase,
  components: {
    SideBarMenu: SideBarMenu,
    Notification,
    Confirmation,
    history,
    ApprovalH,
    ApprovalN
  },
  data: () => ({
    title: 'Dashboard',
    drawer: false,
    fab: false,
    fab2: false,
    offsetTop: 0,
    color: 'blue lighten-1',
    items: {},
    authMenu: []
  }),
  computed: {
    historyData () {
      return this.$store.getters['Dialogs/getHistory']
    },
    ApprovalNData () {
      return this.$store.getters['Dialogs/getApprovalN']
    },
    ApprovalHData () {
      return this.$store.getters['Dialogs/getApproveHistory']
    },
    ...dialogsStore.mapState({
      confirmation: 'confirmation'
    })
  },
  watch: {
    'confirmation.show' (newValue) {
      if (newValue) {
        this.$refs.confirmation.show()
      } else {
        this.$refs.confirmation.close()
      }
    }
  },
  methods: {
    ...dialogsStore.mapActions({
      closeNotification: 'closeNotification'
    }),
    toggleSideBar () {
      this.$store.dispatch('toggleDrawer')
    },
    logout () {
      this.$store.dispatch('logout')
      this.$router.push({ name: 'Login', query: { redirect: '/' } })
    },
    renderAction (action) {
      if (action.hasOwnProperty('render')) {
        return action.render
      } else {
        return true
      }
    },
    onScroll (e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    },
    backtoTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    actionHandler (action) {
      if (action.hasOwnProperty('handler')) {
        action.handler()
      } else {
        return () => {}
      }
    }
  },
  mounted () {
    const self = this

    self.$store.dispatch('Menu/list', {vueinstance: self})
      .then(res => {
        self.$set(self, 'authMenu', res.authMenu.map(x => {
          return {
            title: x.menuName,
            icon: 'explore',
            name: x.routeName,
            id: x.id
          }
        }).filter(x => self.$router.getMatchedComponents(x).length > 0) // filter implemented routes
        )
        // worklist menu
        self.authMenu.push({title: 'Worklist', icon: 'explore', name: 'Worklist'})
        // logout menu
        self.authMenu.push({title: 'LOGOUT', icon: 'exit_to_app', name: 'Logout'})
        self.items = {
          name: res.name,
          profileImage: res.profileImage,
          authorities: res.authorities,
          authMenu: self.authMenu
        }
      })
      .catch(err => {
        self.$error(err)
      })
  }
}
</script>
<style scoped>
.downloadtop >>> .speed-dial__list{
  top: 120% !important;
}
 #create .speed-dial {
    position: absolute;
  }

  #create .btn--floating {
    position: relative;
  }
  @media only screen and (max-width: 599px) {
    .fm-18px{
      font-size: 18px;
    }
  }
  @media only screen and (max-width: 958px) {
    .download{
      right: 65px;
    }
    .scrol-top2{
      right: 65px;
    }
    .scrol-top{
      right: 115px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue